<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Danh sách quyền</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="/dashboard">Dashboard</a>
              </li>
              <li class="breadcrumb-item active">Quyền</li>
            </ul>
          </div>
          <div class="col-auto float-right ml-auto">
            <a
              href="#"
              class="btn add-btn"
              data-toggle="modal"
              data-target="#add_modal"
              @click="loadOptions"
            >
              <i class="fa fa-plus"></i> Thêm quyền
            </a>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="col-md-12">
          <table class="table table-striped custom-table mb-0 datatable">
            <thead>
              <tr>
                <th>Mã quyền</th>
                <th>Tên quyền</th>
                <th>Chức năng</th>
                <th>Hành động</th>
                <th class="text-right">Hành động</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="q in quyenList" :key="q.idQuyen">
                <td>{{ q.maQuyen }}</td>
                <td>{{ q.tenQuyen }}</td>
                <td>{{ q.chucNang }}</td>
                <td>{{ q.hanhDong }}</td>
                <td class="text-right">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        href="#"
                        data-toggle="modal"
                        data-target="#edit_modal"
                        @click="editQuyen(q)"
                      >
                        <i class="fa fa-pencil m-r-5"></i> Sửa
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        data-toggle="modal"
                        data-target="#delete_modal"
                        @click="confirmDelete(q.idQuyen)"
                      >
                        <i class="fa fa-trash-o m-r-5"></i> Xóa
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="quyenList.length === 0 && !loading">
                <td colspan="5" class="text-center">Không có quyền nào.</td>
              </tr>
              <tr v-if="loading">
                <td colspan="5" class="text-center">Đang tải...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="row mt-3">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info">
            Hiển thị {{ currentPage * pageSize + 1 }} đến
            {{ Math.min((currentPage + 1) * pageSize, totalElements) }} của
            {{ totalElements }} mục
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <ul class="pagination">
            <li
              class="paginate_button page-item previous"
              :class="{ disabled: currentPage === 0 }"
            >
              <a
                href="#"
                class="page-link"
                @click.prevent="goToPage(currentPage - 1)"
                >Previous</a
              >
            </li>
            <li
              v-for="pageNum in totalPages"
              :key="pageNum"
              class="paginate_button page-item"
              :class="{ active: pageNum === currentPage + 1 }"
            >
              <a
                href="#"
                class="page-link"
                @click.prevent="goToPage(pageNum - 1)"
              >
                {{ pageNum }}
              </a>
            </li>
            <li
              class="paginate_button page-item next"
              :class="{ disabled: currentPage === totalPages - 1 }"
            >
              <a
                href="#"
                class="page-link"
                @click.prevent="goToPage(currentPage + 1)"
                >Next</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal thêm -->
    <div id="add_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="addQuyen">
            <div class="modal-header">
              <h5 class="modal-title">Thêm quyền</h5>
              <button type="button" class="close" data-dismiss="modal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Mã quyền<span class="text-danger">*</span></label>
                <input
                  v-model="newQuyen.maQuyen"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>Tên quyền<span class="text-danger">*</span></label>
                <input
                  v-model="newQuyen.tenQuyen"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>Chức năng<span class="text-danger">*</span></label>
                <select
                  v-model="newQuyen.idChucNang"
                  class="form-control"
                  required
                >
                  <option value="">-- Chọn chức năng --</option>
                  <option
                    v-for="cn in chucNangs"
                    :key="cn.idChucNang"
                    :value="cn.idChucNang"
                  >
                    {{ cn.tenChucNang }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Hành động<span class="text-danger">*</span></label>
                <select
                  v-model="newQuyen.idHanhDong"
                  class="form-control"
                  required
                >
                  <option value="">-- Chọn hành động --</option>
                  <option
                    v-for="hd in hanhDongs"
                    :key="hd.idHanhDong"
                    :value="hd.idHanhDong"
                  >
                    {{ hd.tenHanhDong }}
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Thêm</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal sửa -->
    <div id="edit_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="updateQuyen">
            <div class="modal-header">
              <h5 class="modal-title">Sửa quyền</h5>
              <button type="button" class="close" data-dismiss="modal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Mã quyền<span class="text-danger">*</span></label>
                <input
                  v-model="currentQuyen.maQuyen"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>Tên quyền<span class="text-danger">*</span></label>
                <input
                  v-model="currentQuyen.tenQuyen"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>Chức năng</label>
                <select v-model="currentQuyen.idChucNang" class="form-control">
                  <option value="">-- Chọn chức năng --</option>
                  <option
                    v-for="cn in chucNangs"
                    :key="cn.idChucNang"
                    :value="cn.idChucNang"
                  >
                    {{ cn.tenChucNang }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Hành động</label>
                <select v-model="currentQuyen.idHanhDong" class="form-control">
                  <option value="">-- Chọn hành động --</option>
                  <option
                    v-for="hd in hanhDongs"
                    :key="hd.idHanhDong"
                    :value="hd.idHanhDong"
                  >
                    {{ hd.tenHanhDong }}
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Lưu</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal xóa -->
    <div id="delete_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body text-center">
            <h3>Bạn có chắc muốn xóa quyền này?</h3>
            <div class="mt-3">
              <button class="btn btn-danger mr-2" @click="deleteQuyen">
                Xóa
              </button>
              <button class="btn btn-secondary" data-dismiss="modal">
                Hủy
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import api from "@/api/index.js";
import { useToast } from "vue-toastification";

const toast = useToast();

const quyenList = ref([]);
const chucNangs = ref([]);
const hanhDongs = ref([]);
const loading = ref(true);

const newQuyen = reactive({
  maQuyen: "",
  tenQuyen: "",
  idChucNang: "",
  idHanhDong: "",
});
const currentQuyen = reactive({
  idQuyen: null,
  maQuyen: "",
  tenQuyen: "",
  idChucNang: "",
  idHanhDong: "",
});
const quyenToDeleteId = ref(null);

const currentPage = ref(0);
const pageSize = ref(10);
const totalElements = ref(0);
const totalPages = ref(0);

const fetchQuyens = async () => {
  loading.value = true;
  try {
    const res = await api.get("/api/quyen", {
      params: { page: currentPage.value, size: pageSize.value },
    });
    quyenList.value = res.data.data.content;
    totalElements.value = res.data.data.totalElements;
    totalPages.value = res.data.data.totalPages;
  } catch {
    toast.error("Không thể tải danh sách quyền");
  } finally {
    loading.value = false;
  }
};

const loadOptions = async () => {
  try {
    const resCN = await api.get("/api/chuc-nang?size=99999");
    chucNangs.value = resCN.data.data.content || resCN.data.data;

    const resHD = await api.get("/api/hanh-dong");
    hanhDongs.value = resHD.data.data.content || resHD.data.data;
  } catch {
    toast.error("Không thể tải danh sách chức năng/hành động");
  }
};

const goToPage = (page) => {
  if (page >= 0 && page < totalPages.value) {
    currentPage.value = page;
    fetchQuyens();
  }
};

const addQuyen = async () => {
  try {
    await api.post("/api/quyen", newQuyen);
    toast.success("Thêm quyền thành công");
    Object.assign(newQuyen, {
      maQuyen: "",
      tenQuyen: "",
      idChucNang: "",
      idHanhDong: "",
    });
    fetchQuyens();
  } catch {
    toast.error("Lỗi khi thêm quyền");
  }
};

const editQuyen = (q) => {
  loadOptions();
  Object.assign(currentQuyen, q);
};

const updateQuyen = async () => {
  try {
    await api.put(`/api/quyen/${currentQuyen.idQuyen}`, currentQuyen);
    toast.success("Cập nhật quyền thành công");
    fetchQuyens();
  } catch {
    toast.error("Lỗi khi cập nhật quyền");
  }
};

const confirmDelete = (id) => {
  quyenToDeleteId.value = id;
};

const deleteQuyen = async () => {
  try {
    await api.delete(`/api/quyen/${quyenToDeleteId.value}`);
    toast.success("Xóa thành công");
    $("#delete_modal").modal("hide");
    fetchQuyens();
  } catch {
    toast.error("Lỗi khi xóa quyền");
  }
};

onMounted(() => {
  fetchQuyens();
  loadOptions();
});
</script>
